import { useQuestionizerStore } from "../types/state";
import Input from "./input";


export default function InputBaujahr (props: {required: boolean, id: number, label: string, onBlur?: ()=>void}){
  const baujahr = useQuestionizerStore((state) => state.baujahr);
  const setBaujahr = useQuestionizerStore((state) => state.setBaujahr);
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);

  const label_input = useQuestionizerStore((state) => state.L('input-baujahr--input'));
  
  return <div className={"input-container input-"+props.id}>
       <Input<number> id={props.id} required={props.required} label={props.label || label_input} value={baujahr} onBlur={props.onBlur} onChange={(value)=>{
          //validation(value);
          const processed_value = parseInt(value.toString().replace(/\D+/,"").slice(0,4));
          setBaujahr(processed_value);
          updateValidation();
        }} type="text"/>
  </div>
}
